import dayjs from "dayjs";

const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return dayjs(dateStr).format("YYYY-MM-DD");
};

export const buildEmployeeProfilePayload = (values, editData=null) => ({
    ...(editData && { EMPID: editData.ID }), // ✅ ONLY FOR EDIT
    CorporationID: values.corporation,
    Salutation: values.salutation ? Number(values.salutation) : 0,
    FirstName: values.firstName,
    MiddleName: values.middleName,
    LastName: values.lastName,
    Gender: values.gender ? Number(values.gender) : null,
    SSN: values.ssn || "",
    CheckToBePrintedAs: values.checksToBePrintedAs || "",
    IsActive: values.active ? 1 : 0
});


export const buildPayrollPayload = (values, editData=null) => ({
    PayrollDetails: (values.payrollRows || []).flatMap((row) =>
        (row.payrollItems || []).map((item, index) => {
            const currentItem = row.payrollItems[index];

            // console.log("ITEM", index, item);

            return {
            ...(currentItem?.payrollDetailId != null && {
                Id: currentItem.payrollDetailId,
            }),


            IsDefault: row.isDefault === 1,

            Department: row.department ? String(row.department) : null,
            DeptName: row.departmentName || "",

            JobTitle: row.jobTitle ? String(row.jobTitle) : null,
            JobName: row.jobTitleName || "",

            PCID: row.profitCenter ? String(row.profitCenter) : null,

            PayrollDeptJobId: currentItem?.payrollDeptJobId || 0,

            PayrollItemId: currentItem?.payrollItemId || "",

            ItemName: currentItem?.itemName || "",

            COA: currentItem?.account || "",

            Rate: parseFloat(currentItem?.rate) || 0,

            IsActive: true,
            };
        })
    )
});



export const buildAddressPayload = (values, editData=null) => ({
    ...(editData && {
        AddressId: editData.AddressID || null,
        ContactId: editData.ContactID || null,
        RelationContactId: editData.RelationContactID || null
    }),
    SaveAddressReq: {
        ...(editData?.AddressID && { ID: editData.AddressID }), // 👈 EDIT
        IsActive: true, // ✅ BOOLEAN

        AddressName: values.addressDetails?.addressName || null,
        Adress: values.addressDetails?.address || null,
        City: values.addressDetails?.city || null,

        StateID: values.addressDetails?.stateId
            ? String(values.addressDetails.stateId)
            : null,

        StateName: values.addressDetails?.stateName || "",
        StateCode: values.addressDetails?.stateCode || "",

        CountryID: values.addressDetails?.countryId
            ? Number(values.addressDetails.countryId)
            : null,

        CountryName: values.addressDetails?.countryName || "",
        CountryCode: values.addressDetails?.countryCode || "",

        ZipCode: values.addressDetails?.zipCode || null
    },

    RelationContactReq: [
        {
            // ✅ EMPLOYEE CONTACT (ALWAYS INDEX 0)
            ...(editData?.ContactID && { ID: editData.ContactID }),
            IsActive: true,
            ContactName: `${values.firstName} ${values.lastName}` || "",
            MobileNum: String(values.mobileNumber) || "",
            HomeNum: values.employmentInfo?.additionalInfo?.homeNum || "",
            AlternativeNum: values.employmentInfo?.additionalInfo?.alternativeNum || null,
            WorkNum: values.employmentInfo?.additionalInfo?.workNum || null,
            FaxNum: values.employmentInfo?.additionalInfo?.faxNum || null,
            EmailID: values.emailId || ""
        },
        {
            ...(editData?.EmergencyContactID && {
                ID: editData.EmergencyContactID
            }), // 👈 EDIT
            IsActive: true, // ✅ BOOLEAN

            RelationId: values.emergencyContact?.relationId || null,
            Name: values.emergencyContact?.relationName || "",
            ContactName: values.emergencyContact?.name || "",

            MobileNum :values.emergencyContact?.mobileNum || "",
            //HomeNum: values.emergencyContact?.homeNum || "",
            //AlternativeNum: values.emergencyContact?.alternativeNum || null,
            WorkNum: values.emergencyContact?.workNum || null,
            FaxNum: values.emergencyContact?.faxNum || null,
            EmailID: values.emergencyContact?.emailId || null
        }
    ]
    
});


// ===============================
// Employment + Job Details
// ===============================
export const buildEmploymentPayload = (values, editData=null) => ({
    ...(editData && { EMPID: editData.ID }), // 👈 REQUIRED FOR EDIT
    DOB: formatDate(values.employmentInfo?.employeeDetails?.dob),
    MaritalStatus: values.maritalStatus || 0,
    

    BankID: values.employmentInfo?.additionalInfo?.bankId ?? null,                                 // 👈 avoid FK crash
    BankName: values.employmentInfo?.additionalInfo?.bankName || "",
    BankAccountNum: values.employmentInfo?.additionalInfo?.bankACNum || "",

    EmploymentDetailsRequest: {
        ...(editData?.EmploymentDetailID && {
            ID: editData.EmploymentDetailID
        }), // 👈 EDIT
        
        HireDate: formatDate(values.employmentInfo?.employeeDetails?.hireDate),
        StartDate: formatDate(values.employmentInfo?.employeeDetails?.startDate),
        USCitizen: Boolean(values.employmentInfo?.employeeDetails?.usCitizen),
        I9file: Boolean(values.employmentInfo?.employeeDetails?.i9OnFile),
        I9ExpiryDate: formatDate(values.employmentInfo?.employeeDetails?.i9ExpirationDate),

        LCAState:
            values.employmentInfo?.jobDetails?.lcaState !== ""
                ? Number(values.employmentInfo.jobDetails.lcaState)
                : null,

        LCAGC:
            values.employmentInfo?.jobDetails?.lcaGC !== ""
                ? Number(values.employmentInfo.jobDetails.lcaGC)
                : null,

        // ✅ Dropdown numeric
        JobType: values.employmentInfo?.jobDetails?.jobType || 0,

        TerminationType: Number(values.employmentInfo?.terminationDetails?.terminationType) || 0,

        TerminationReason:
            values.employmentInfo?.terminationDetails?.terminationReason || "",

        LastDayWorked: formatDate(values.employmentInfo?.terminationDetails?.lastDayWorked),
        LastDayOnBenifits: formatDate(values.employmentInfo?.terminationDetails?.lastDayOnBenefits),
        ReleaseDate: formatDate(values.employmentInfo?.terminationDetails?.releaseDate)
    }
});


// ===============================
// Delete Payroll Detail Function
// ===============================
export const deletePayrollDetail = (payload, payrollId) => {
    return {
        ...payload,
        PayrollDetails: payload.PayrollDetails.filter(detail => detail.Id !== payrollId && detail.ID !== payrollId && detail.PayrollDetailID !== payrollId)
    };
};
